export default __webpack_public_path__ + "static/media/mm-logo.45038d58.svg";